import { OrgId } from "@hex/common";

import { GLOBAL_ORG_ID } from "../../orgs";

type SsoLoginMode =
  | { type: "direct"; orgId: OrgId }
  | { type: "workspaceDiscovery" }
  | { type: "none" };

export function getSsoLoginMode({
  allowGlobalSso,
  orgId,
  ssoEnabled,
}: {
  allowGlobalSso: boolean;
  orgId: OrgId | undefined;
  ssoEnabled: boolean;
}): SsoLoginMode {
  if (orgId == null && !allowGlobalSso) {
    return { type: "workspaceDiscovery" };
  }

  if (!ssoEnabled) {
    return { type: "none" };
  }

  return { type: "direct", orgId: orgId ?? GLOBAL_ORG_ID };
}
